import { Button, Form, Input, message, Select } from 'antd';
import { getSelectList, SelectList, SelectPayload } from 'api/dashboard';
//import { useLoginValidation } from "api/auth";
import { addSourceList, AddSourcePayload } from 'api/master';
import { UserPayload } from 'api/profile';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  isAdmin: boolean;
  onSubmit: (values: AddSourcePayload) => Promise<void>;
};

const filterPayload: AddSourcePayload = {};
const initPartners: SelectList[] = [];
const inituser: UserPayload = {};

const AddSource = ({ onSubmit }: Props) => {
  const navigate = useNavigate();
  const { Option } = Select;
  const [filter, setFilter] = useState(filterPayload);
  const [form] = Form.useForm<AddSourcePayload>();
  const [statusList, setStatus] = useState(initPartners);
  const [user, _setUser] = useState(inituser);
  const [_statusId, setStatusId] = useState(0);

  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'LoanType',
    };

    // setIsLoading(false);
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });
  }, []);

  //const validation = useLoginValidation();
  const handleSubmit = useCallback(
    async (values: AddSourcePayload) => {
      debugger;
      values.CreatedBy = sessionStorage.getItem('user')?.toString;
      values.SoftCell = '1';
      values.userId = user.userId;
      values.Username = sessionStorage.getItem('user')?.toString;
      values.loanTypes = values.loanTypes?.toString();

      addSourceList(values)
        .then((_res) => {
          debugger;
          if (_res.responseCode == '200' && _res.message == 'Source Name Added!') {
            message.success('Source Name Added Succesfully!');
          }
          if (_res.responseCode == '200' && _res.message == 'SourceName Already Added!') {
            message.warn('SourceName Already Added!');
          }
        })
        .finally(() => {
          form.resetFields();
          navigate('/master/source');
        });
    },
    [onSubmit, form, user]
  );

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }

  const handleLoanId = (e: any) => {
    // debugger;
    // form.setFieldValue('statusId', e);
    // form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Add Source</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    //['SourceApplicationName']: sessionStorage.getItem('source')?.toString(),
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item
                          label={'Source Application Name :'}
                          name="SourceApplicationName"
                          className="fieldTitle"
                          rules={[
                            { required: true, message: 'Please enter Source Application Name!' },
                          ]}
                          style={{ marginBottom: '20px' }}
                        >
                          <Input placeholder={'Source Application Name'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item
                          label={'Type of Application :'}
                          name="TypeofApplication"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please enter Type of Application!' }]}
                        >
                          <Select
                            defaultValue={'Select'}
                            size="large"
                            //value={statusId.toString()}
                            //onSelect={handleStatusId}
                          >
                            <Option value="Mobile">Mobile</Option>
                            <Option value="Web">Web</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col-xs-12 col-sm-6 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Secret Key :'} name="SecretKey" className="fieldTitle">
                                                    <Input placeholder={'Secret Key'} />
                                                </Form.Item>
                                            </div>
                                        </div> */}

                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Success Url :'} name="successUrl" className="fieldTitle">
                          <Input placeholder={'Success Url'} />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Failure Url :'} name="failureUrl" className="fieldTitle">
                          <Input placeholder={'Failure Url'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Loan Type:'} name="loanTypes">
                          {/* <Select
                                placeholder="Please select loan type"
                                size="large"
                                mode="multiple"
                              >
                                <Option value="EL">EL</Option>
                                <Option value="EIL">EIL</Option>
                                <Option value="BLPREAPP">BLPREAPP</Option>
                                <Option value="BLSME">BLSME</Option>
                                <Option value="DIGPL">DIGPL</Option>
                                <Option value="DIGPRO">DIGPRO</Option>
                                <Option value="DIGPRO1">DIGPRO1</Option>
                                <Option value="ELDOMC">ELDOMC</Option>
                                <Option value="ELFORN">ELFORN</Option>
                                <Option value="LAPPREAP">LAPPREAP</Option>
                                <Option value="LAPSME">LAPSME</Option>
                                <Option value="PLPREAPP">PLPREAPP</Option>
                                <Option value="VOC">VOC</Option>
                                <Option value="MEL-CROSSSELL">MEL-CROSSSELL</Option>
                                <Option value="MEL-BL">MEL-BL</Option>
                                <Option value="MEL-PL">MEL-PL</Option>
                                <Option value="MEL-LAP">MEL-LAP</Option>
                                <Option value="SME-LAP">SME-LAP</Option>
                                <Option value="SME-BL">SME-BL</Option>
                                <Option value="DIGTOP">DIGTOP</Option>
                                <Option value="SFFPESIL">SFFPESIL</Option>
                                <Option value="SSFGYA">SSFGYA</Option>
                                <Option value="EILGECL">EILGECL</Option>
                                <Option value="SILGECL">SILGECL</Option>
                                <Option value="SSFWESIL">SSFWESIL</Option>
                                <Option value="SSFGYAW">SSFGYAW</Option>
                                <Option value="SCHOOLFE">SCHOOLFE</Option>
                                <Option value="TESTPREP">TESTPREP</Option>
                                <Option value="TUTIONFE">TUTIONFE</Option>
                                <Option value="UPSKLNG">UPSKLNG</Option>
                                <Option value="DIGJODO">DIGJODO</Option>
                                <Option value="SFFCREFA">SFFCREFA</Option>
                                <Option value="SFTCPSIL">SFTCPSIL</Option>
                                <Option value="DIGPL1">DIGPL1</Option>
                                <Option value="SFEDUSIL">SFEDUSIL</Option>
                                <Option value="CSLOAN">CSLOAN</Option>
                                <Option value="SCFEIL">SCFEIL</Option>
                                <Option value="PAPL">PAPL</Option>
                                <Option value="PAVL">PAVL</Option>
                                <Option value="PAVL2">PAVL2</Option>
                                <Option value="DIGPRATI">DIGPRATI</Option>
                                <Option value="VOCGL">VOCGL</Option>
                              </Select> */}

                          <Select
                            placeholder="Please select loan type"
                            size="large"
                            mode="multiple"
                            onSelect={handleLoanId}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      {user.userId != null ? (
                        <>
                          <div className="input-box">
                            <Form.Item label={'Admin user :'} name="user" className="fieldTitle">
                              <span style={{ color: 'green' }}>{user.emailID}</span>
                              {/* <Input placeholder={user.emailID} value={user.emailID} disabled={true} color="green" /> */}
                            </Form.Item>
                          </div>
                        </>
                      ) : // : (
                      //   <div className="input-box" style={{ marginTop: '32px' }}>
                      //     <Button onClick={handleAddUser}>Add Admin User</Button>
                      //   </div>
                      null}
                    </div>
                  </div>
                  <div className="row"></div>
                  <div className="payment-button">
                    <Button className="proceed-btn" id="btnSubmit" htmlType="submit" size="small">
                      ADD
                    </Button>
                    <Button
                      id="btnClear"
                      className="proceed-btn"
                      size="small"
                      style={{ marginLeft: '10px' }}
                      onClick={handleReset}
                    >
                      CLEAR
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSource;
